import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/rubrosReducer/actions'
import * as Notifications from '../../components/Common/notification'

import * as layoutActions from '../../reducers/layoutReducer/actions'

function* genGetRubros(e){
    try {
        if (!e.comboBox) yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo rubros' }))
        // llamo a la acción que trae los rubros
        let rubros = yield calls.getRubros(e.query, e.activos ,e.comboBox)
        yield put(reducerActions.setRubros(rubros))
        
    }
    catch (error) 
    {
        if (error.Message) {

            return;
        }
    }
    finally{
      if(!e.comboBox) yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genGetSuperRubros(){
    try {
        
        // llamo a la acción que trae los superRubros
        let superRubros = yield calls.getSuperRubros()
        yield put(reducerActions.setSuperRubros(superRubros))
        
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    
}

function* genGetRubro(e){
    try {
        
      yield put(layoutActions.setLoading({ show: true, message: 'Cargando rubro' }))
        // llamo a la acción que trae los rubros
        let rubro = yield calls.getRubro(e.payload.id)
        yield put(reducerActions.saveRubro(rubro))
        
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
        
      yield put(layoutActions.setLoading({ show: false }))
    }
}
function* genSwapRubro(e){
    try {
        
      //yield put(layoutActions.setLoading({ show: true, message: 'Cambiando orden de rubros' }))
        // llamo a la acción que trae los rubros
        if(!e.payload.canSwap) {
            Notifications.showError("No se permite ordenar los items de una busqueda. Por favor limpie la busqueda.")
        }
        else {
            let rubros = yield calls.swapRubro(e.payload)
            yield put(reducerActions.setRubros(rubros))
            Notifications.showSuccess("Rubro desplazado ")
        }
        
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
      yield put(layoutActions.setLoading({ show: false}))
    }
}
function* genSwapSubRubro(e){
    try {
        
      //yield put(layoutActions.setLoading({ show: true, message: 'Cambiando orden de subrubros' }))
        // llamo a la acción que trae los subrubros
        //yield calls.swapSubRubros(e.from, e.to)
        
        let subrubros = yield calls.swapSubRubro(e.payload)
        yield put(reducerActions.setSubRubros(subrubros))
        Notifications.showSuccess("SubRubro desplazado ")
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
        
      yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genGetSubrubros(e){
    try {
      
        if(!e.comboBox) yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo subrubros' }))
        // llamo a la acción que trae los rubros
        let rubros = yield calls.getSubrubros(e.payload, e.query, e.comboBox)
        yield put(reducerActions.setSubRubros(rubros))
        
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
        if(!e.comboBox)
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSaveImagenRubros(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.saveImagen(e.payload)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSaveRubro(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.saveRubro(e.payload)
        if(e.payload.idRubro !== 0)
        Notifications.showSuccess("rubro actualizado ")
        else
        Notifications.showSuccess("rubro creado ")
        
        window.history.back();

    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSaveSubRubro(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.saveSubRubro(e.payload)
        if(e.payload.idSubrubro !== 0)
        Notifications.showSuccess("subrubro actualizado ")
        else
        Notifications.showSuccess("subrubro creado ")
        
        window.history.back();
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}


function* genGetSubRubro(e){
    try {
        
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando subrubro' }))
        // llamo a la acción que trae los rubros
        let rubro = yield calls.getSubRubro(e.payload.id)
        yield put(reducerActions.saveSubRubro(rubro))
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
        
        yield put(layoutActions.setLoading({ show: false }))
    }
}


function* genSaveEstado(e){
    try {
        // llamo a la acción que guarda el catálogo
        let cambios = {}
        //llamadas
        cambios[reducerActions.ELIMINAR_RUBRO] = calls.eliminiarRubro;
        cambios[reducerActions.REVERTIR_RUBRO] = calls.revertirRubro;
        cambios[reducerActions.ELIMINAR_SUBRUBRO] = calls.eliminarSubRubro;
        cambios[reducerActions.REVERTIR_SUBRUBRO] = calls.revertirSubRubro;
        let success = yield cambios[e.type](e.payload.id)

        //mensajes de exito
        cambios[reducerActions.ELIMINAR_RUBRO] = "Rubro eliminado";
        cambios[reducerActions.REVERTIR_RUBRO] = "Rubro reactivado";
        cambios[reducerActions.ELIMINAR_SUBRUBRO] = "Subrubro eliminado";
        cambios[reducerActions.REVERTIR_SUBRUBRO] = "Subrubro reactivado";

        if (success === true) Notifications.showSuccess(cambios[e.type])
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genGetSubrubroPicking(e){
    try {
        
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando subrubros' }))
        // llamo a la acción que trae los rubros
        let subrubros = yield calls.getSubrubrosPicking()

        yield put(reducerActions.saveSubRubrosPicking(subrubros))
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
        
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSwapSubRubroPicking(e){
    try {
        
      //yield put(layoutActions.setLoading({ show: true, message: 'Cambiando orden de subrubros' }))
        // llamo a la acción que trae los subrubrosPicking
        //yield calls.swapSubRubrosPicking(e.from, e.to)

        let subrubrosPicking = yield calls.swapSubRubroPicking(e.payload)

        yield put(reducerActions.saveSubRubrosPicking(subrubrosPicking))

        Notifications.showSuccess("SubRubro desplazado ")

    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
    finally{
      yield put(layoutActions.setLoading({ show: false}))
    }
}

function* defaultSaga() {
    yield all([      
        takeLatest(reducerActions.SAGA_GET_SUPERRUBROS_COMBO, genGetSuperRubros),   
        takeLatest(reducerActions.SAGA_GET_RUBROS, genGetRubros),
        takeLatest(reducerActions.SAGA_SWAP_RUBRO, genSwapRubro),
        takeLatest(reducerActions.SAGA_GET_SUBRUBROS, genGetSubrubros),
        takeLatest(reducerActions.SAGA_SWAP_SUBRUBRO, genSwapSubRubro),
        takeLatest(reducerActions.SAGA_SAVE_IMAGEN_RUBRO, genSaveImagenRubros),
        takeLatest(reducerActions.SAGA_SAVE_RUBRO, genSaveRubro),
        takeLatest(reducerActions.SAGA_GET_RUBRO_ID, genGetRubro),        
        takeLatest(reducerActions.SAGA_GET_SUBRUBRO_ID, genGetSubRubro),
        takeLatest(reducerActions.SAGA_SAVE_SUBRUBRO, genSaveSubRubro ),

        takeLatest(reducerActions.ELIMINAR_RUBRO, genSaveEstado ),
        takeLatest(reducerActions.ELIMINAR_SUBRUBRO, genSaveEstado ),
        takeLatest(reducerActions.REVERTIR_RUBRO, genSaveEstado ),
        takeLatest(reducerActions.REVERTIR_SUBRUBRO, genSaveEstado ),
        takeLatest(reducerActions.SAGA_GET_SUBRUBROS_PICKING, genGetSubrubroPicking ),
        takeLatest(reducerActions.SAGA_SWAP_SUBRUBRO_PICKING, genSwapSubRubroPicking ),
    ])
  }
  
  export const sagas = [
    defaultSaga
  ]